"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const emailopen = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-emailopen` : '') + (description ? ` desc-emailopen` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-emailopen"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-emailopen"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2055)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 0C19.241 0 20.25 1.009 20.25 2.25V11.328L20.818 10.878C21.082 10.669 21.413 10.554 21.749 10.554C22.211 10.554 22.639 10.761 22.926 11.122C23.135 11.386 23.25 11.716 23.251 12.052V21.753C23.251 22.994 22.242 24.003 21.001 24.003L3 24.002C1.759 24.002 0.75 22.993 0.75 21.752V12.052C0.750941 11.2736 1.34715 10.6326 2.10593 10.5599L2.279 10.553C2.592 10.553 2.922 10.672 3.182 10.878L3.75 11.329V2.25C3.75 1.009 4.759 0 6 0H18ZM21.75 12.052L14.319 17.946C13.657 18.466 12.834 18.751 11.999 18.751C11.165 18.751 10.343 18.466 9.683 17.948L2.25 12.053V21.752C2.25 22.166 2.586 22.502 3 22.502H21C21.414 22.502 21.75 22.166 21.75 21.752V12.052ZM17.999 1.5H6C5.586 1.5 5.25 1.836 5.25 2.25V12.518L10.613 16.771C11.013 17.084 11.493 17.251 11.999 17.251C12.507 17.251 12.988 17.084 13.389 16.769L18.749 12.518V2.25C18.749 1.836 18.413 1.5 17.999 1.5ZM15.75 10.5C16.164 10.5 16.5 10.836 16.5 11.25C16.5 11.664 16.164 12 15.75 12H8.25C7.836 12 7.5 11.664 7.5 11.25C7.5 10.836 7.836 10.5 8.25 10.5H15.75ZM15.75 7.5C16.164 7.5 16.5 7.836 16.5 8.25C16.5 8.664 16.164 9 15.75 9H8.25C7.836 9 7.5 8.664 7.5 8.25C7.5 7.836 7.836 7.5 8.25 7.5H15.75ZM11.25 4.5C11.664 4.5 12 4.836 12 5.25C12 5.664 11.664 6 11.25 6H8.25C7.836 6 7.5 5.664 7.5 5.25C7.5 4.836 7.836 4.5 8.25 4.5H11.25Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2055"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = emailopen;